import { render, staticRenderFns } from "./ModalPublishItem.vue?vue&type=template&id=19884a9e&scoped=true"
import script from "./ModalPublishItem.vue?vue&type=script&lang=js"
export * from "./ModalPublishItem.vue?vue&type=script&lang=js"
import style0 from "./ModalPublishItem.vue?vue&type=style&index=0&id=19884a9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19884a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19884a9e')) {
      api.createRecord('19884a9e', component.options)
    } else {
      api.reload('19884a9e', component.options)
    }
    module.hot.accept("./ModalPublishItem.vue?vue&type=template&id=19884a9e&scoped=true", function () {
      api.rerender('19884a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalPublishItem.vue"
export default component.exports